<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="600"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:100px;">
      <a-spin :spinning="confirmLoading">
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合作伙伴">
            <a-select
              placeholder="请选择已绑定的伙伴"
              v-decorator="['partnerTenantId', validatorRules.partnerTenantId]"
              show-search
              :filter-option="filterPartnerOption"
              @change="handlePartnerChange">
              <a-select-option v-for="p in partnerList" :key="p.partnerTenantId" :value="p.partnerTenantId">
                {{ p.partnerName }}（{{ p.partnerTenantId }}）
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本方商品">
            <a-select
              placeholder="输入名称搜索本方商品"
              v-decorator="['materialId', validatorRules.materialId]"
              show-search
              :filter-option="false"
              @search="handleSearchMaterial">
              <a-select-option v-for="m in materialList" :key="m.id" :value="m.id">
                {{ materialLabel(m) }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="对方商品">
            <a-select
              placeholder="请先选择伙伴，再输入名称搜索对方商品"
              v-decorator="['partnerMaterialId', validatorRules.partnerMaterialId]"
              show-search
              :filter-option="false"
              :disabled="!currentPartnerTenantId"
              @search="handleSearchPartnerMaterial">
              <a-select-option v-for="m in partnerMaterialList" :key="m.id" :value="m.id">
                {{ materialLabel(m) }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { getPartners, getMaterials, addItemMap } from '@/api/plugin/orderReceive'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'ItemMapModal',
  mixins: [mixinDevice],
  data() {
    return {
      title: '新增商品映射',
      visible: false,
      confirmLoading: false,
      currentPartnerTenantId: null,
      partnerList: [],
      materialList: [],
      partnerMaterialList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      validatorRules: {
        partnerTenantId: { rules: [{ required: true, message: '请选择合作伙伴!' }] },
        materialId: { rules: [{ required: true, message: '请选择本方商品!' }] },
        partnerMaterialId: { rules: [{ required: true, message: '请选择对方商品!' }] }
      }
    }
  },
  methods: {
    add() {
      this.edit()
    },
    edit() {
      this.form.resetFields()
      this.currentPartnerTenantId = null
      this.partnerMaterialList = []
      this.visible = true
      this.loadPartners()
      this.loadMaterials('')
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    // 已绑定伙伴列表
    loadPartners() {
      getPartners({ currentPage: 1, pageSize: 100 }).then((res) => {
        if (res.code === 200) {
          const rows = (res.data && res.data.rows) || []
          this.partnerList = rows
        }
      })
    },
    // 本方商品下拉（名称前缀搜索）
    loadMaterials(name) {
      getMaterials({ name: name || '' }).then((res) => {
        if (res.code === 200) {
          this.materialList = res.data || []
        }
      })
    },
    // 对方商品下拉（需先选伙伴，名称前缀搜索）
    loadPartnerMaterials(name) {
      if (!this.currentPartnerTenantId) {
        return
      }
      getMaterials({ name: name || '', partnerTenantId: this.currentPartnerTenantId }).then((res) => {
        if (res.code === 200) {
          this.partnerMaterialList = res.data || []
        }
      })
    },
    handleSearchMaterial(value) {
      this.loadMaterials(value)
    },
    handleSearchPartnerMaterial(value) {
      this.loadPartnerMaterials(value)
    },
    handlePartnerChange(value) {
      this.currentPartnerTenantId = value
      // 切换伙伴后清空已选的对方商品
      this.form.setFieldsValue({ partnerMaterialId: undefined })
      this.partnerMaterialList = []
      this.loadPartnerMaterials('')
    },
    filterPartnerOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) > -1
    },
    materialLabel(m) {
      return m.unit ? m.name + '（' + m.unit + '）' : m.name
    },
    handleOk() {
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          addItemMap(values).then((res) => {
            if (res.code === 200) {
              that.$message.success('新增映射成功')
              that.$emit('ok')
            } else {
              that.$message.warning(res.message || '新增失败')
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
<style scoped>
</style>
